import React, { useState } from 'react';
import { Button } from './ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from './ui/dialog';
import { MessageCircleQuestion } from 'lucide-react';
import SupportForm from './SupportForm';

export const FloatingSupportButton = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [showButton, setShowButton] = useState(true);

    const handleSuccess = () => {
        // Close modal after a delay on success
        setTimeout(() => {
            setIsOpen(false);
        }, 3000);
    };

    // Don't show on certain pages (admin, login, etc.)
    if (typeof window !== 'undefined') {
        const path = window.location.pathname;
        if (path.startsWith('/admin') || path === '/login' || path === '/contact') {
            return null;
        }
    }

    return (
        <>
            {/* Floating Button - Desktop: bottom-right, subtle */}
            {showButton && (
                <div className="fixed bottom-6 right-6 z-50" data-testid="floating-support-btn">
                    <Button
                        onClick={() => setIsOpen(true)}
                        className="rounded-full h-14 px-5 shadow-lg bg-accent hover:bg-accent/90 text-accent-foreground transition-all hover:scale-105"
                        aria-label="Open support form"
                    >
                        <MessageCircleQuestion className="h-5 w-5 mr-2" />
                        <span className="font-medium">Questions?</span>
                    </Button>
                </div>
            )}

            {/* Support Modal */}
            <Dialog open={isOpen} onOpenChange={setIsOpen}>
                <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
                    <DialogHeader>
                        <DialogTitle className="font-serif text-xl">Contact Support</DialogTitle>
                        <DialogDescription>
                            Have a question or need help? Send us a message and we'll get back to you.
                        </DialogDescription>
                    </DialogHeader>
                    <SupportForm 
                        onSuccess={handleSuccess}
                        onCancel={() => setIsOpen(false)}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default FloatingSupportButton;
